import { asyncAction, syncAction } from '@/lib/action';

export const getEventsAction = asyncAction('EVENTS/GET_EVENTS');
export const clearEventsAction = syncAction('EVENTS/CLEAR_LIST');
export const getCountOfNewEventsAction = asyncAction('EVENTS/GET_COUNTER_OF_NEW');
export const toggleEventPanelAction = syncAction('EVENT/TOGGLE_PANEL');
export const exportHistoryEventsAction = syncAction('EVENT/EXPORT_HISTORY_EVENTS');
